import React, { useState, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import axios from 'axios'
import { AuthContext } from '../../../contexts/AuthContext';
import { apiRoutes } from '../../../AppSettings';
import Util from '../../../Util';
import alertify from 'alertifyjs';

const EditTimeModel = (props) => {

    let scheduleTimes = props.body;
    let day = props.day;
    let [scheduleTime, setScheduleTime] = useState(scheduleTimes);
    const [addedscheduleTimingId , setAddedscheduleTimingId] = useState(0);
    const { userState } = useContext(AuthContext);
  
    scheduleTime = scheduleTimes;

    const options = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'bearer '+ userState.token
        }
    };

    const AddMore = () => {
        setAddedscheduleTimingId(addedscheduleTimingId - 1);
        let newTime = {
            scheduleTimingId: addedscheduleTimingId,
            startTime: "-",
            endTime: "-",
            day: day,
            error: '',
            doctorId: userState.user.userId
        } 

        scheduleTime.push(newTime);
    }

    const deleteItem =(scheduleTimingId) => {
         for( var i = 0; i < scheduleTime.length; i++)
         {
            if(scheduleTime[i].scheduleTimingId === scheduleTimingId)
            {
                scheduleTime.splice(i, 1);
                break;
            }
         }

        axios.post(apiRoutes.deleteSchedule, JSON.stringify({scheduleTimingId: scheduleTimingId}), options)
        .then((response) => {
            if(response.status === 200)
            {
                console.log(response.data);
                alertify.success("Selected schedule deleted");
            }
        }, (error) => {
            console.log(error.response);
            alertify.error(Util.getErrorMessages(error.response.data.errorMessages));
        });
    }

    const handleonChange = (e, scheduleTimingId, field) => {
        console.log(scheduleTime);
        scheduleTime.forEach(element => {
            if(element.scheduleTimingId == scheduleTimingId)
            {
                if(field === 'startTime'){
                    if(element.startTime == '-')
                    {
                        element.startTime =  e.target.value;
                        element.error = '';
                    }

                    if(element.endTime != '-' && ValidateChangeTIme(e.target.value, element.endTime))
                    {
                        element.startTime =  e.target.value;
                        element.error = '';
                    }
                    else 
                    {
                        element.error = 'End time should be after start time.';
                    }
                } else {
                    
                    if(element.endTime == '-')
                    {
                        element.endTime = e.target.value;
                        element.error = '';
                    }

                    if(element.startTime != '-' && ValidateChangeTIme(element.startTime, e.target.value))
                    {
                        element.endTime = e.target.value;
                        element.error = '';
                    }
                    else 
                    {
                        element.error = 'End time should be after start time.';
                    }
                }
            }
        })
        AddMore();
        scheduleTime.splice(scheduleTime.length - 1, 1);
    }

    const saveHandler = () => {
        axios.post(apiRoutes.upsertScheduleTime, JSON.stringify(scheduleTime), options)
            .then((response) => {
                if(response.status === 200)
                {
                    alertify.success("Scheduled saved successfully");
                    window.location.reload();
                }
            }, (error) => {
                console.log(error.response);
                alertify.error(Util.getErrorMessages(error.response.data.errorMessages));
        });
    }

    const ValidateChangeTIme = (startTime, endTime) => {
        
        var time = startTime.split(':')
        var startHour = time[0];
        var startMinute = time[1].split(' ')[0];
        var startAMPM = time[1].split(' ')[1];
        if(startAMPM === 'PM')
        {
            startHour = parseInt(startHour) == 12 ? 0 : 12 + parseInt(startHour);
        }

        var time = endTime.split(':')
        var endHour = time[0];
        var endMinute = time[1].split(' ')[0];
        var endAMPM = time[1].split(' ')[1];

        if(startAMPM === 'PM')
        {
            endHour = parseInt(endHour) == 12 ? 0 : 12 + parseInt(endHour);
        }
        
       
        //Create date object and set the time to that
        var startTimeObject = new Date();
        startTimeObject.setHours(startHour, startMinute, 0);
       
        //Create date object and set the time to that
        var endTimeObject = new Date(startTimeObject);
        endTimeObject.setHours(endHour, endMinute, 0);
       
        //Now we are ready to compare both the dates
        if(startTimeObject >= endTimeObject)
        {
            console.log(startTimeObject);
            console.log(endTimeObject);
            return false;
            // alert('End time should be after start time.');
        }
        else
        {
            console.log(startTimeObject);
            console.log(endTimeObject);
            return true;
            //alert('Entries are perfect.');
        }
    }

    return (  
        <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Time Slots
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className="modal-body">
                    <div className="hours-info">
                        {
                            scheduleTime.map(s => (
                                <div key={s}>
                                    <div className="row form-row hours-cont">
                                        <div className="col-12 col-md-10">
                                            <div className="row form-row">
                                                <div className="col-12 col-md-6">
                                                    <div className="form-group">
                                                        <label>Start Time</label>
                                                        <select className="select form-control" value={s.startTime} onChange={(e) => handleonChange(e, s.scheduleTimingId, 'startTime')}>
                                                            <option>-</option>
                                                            <option>09:00 AM</option>
                                                            <option>09:30 AM</option>
                                                            <option>10:00 AM</option>
                                                            <option>10:30 AM</option>
                                                            <option>11:00 AM</option>
                                                            <option>11:30 AM</option>
                                                            <option>12:00 AM</option>
                                                            <option>12:30 PM</option> 
                                                            <option>01:00 PM</option>
                                                            <option>01:30 PM</option>
                                                            <option>02:00 PM</option>
                                                            <option>02:30 PM</option>
                                                            <option>03:00 PM</option>
                                                            <option>03:30 PM</option>
                                                            <option>04:00 PM</option>
                                                            <option>04:30 PM</option>
                                                            <option>05:00 PM</option>
                                                            <option>05:30 PM</option>
                                                            <option>06:00 PM</option>
                                                            <option>06:30 PM</option>
                                                            <option>07:00 PM</option>
                                                            <option>07:30 PM</option>
                                                            <option>08:00 PM</option>
                                                            <option>08:30 PM</option>
                                                            <option>09:00 PM</option>
                                                            <option>09:30 PM</option>
                                                            <option>10:00 PM</option>
                                                            <option>10:30 PM</option>
                                                        </select>
                                                    </div> 
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <div className="form-group">
                                                        <label>End Time</label>
                                                        <select className="select form-control" value={s.endTime} onChange={(e) => handleonChange(e, s.scheduleTimingId, 'endTime')}>
                                                            <option>-</option>
                                                            <option>09:00 AM</option>
                                                            <option>09:30 AM</option>
                                                            <option>10:00 AM</option>
                                                            <option>10:30 AM</option>
                                                            <option>11:00 AM</option>
                                                            <option>11:30 AM</option>
                                                            <option>12:00 AM</option>
                                                            <option>12:30 PM</option> 
                                                            <option>01:00 PM</option>
                                                            <option>01:30 PM</option>
                                                            <option>02:00 PM</option>
                                                            <option>02:30 PM</option>
                                                            <option>03:00 PM</option>
                                                            <option>03:30 PM</option>
                                                            <option>04:00 PM</option>
                                                            <option>04:30 PM</option>
                                                            <option>05:00 PM</option>
                                                            <option>05:30 PM</option>
                                                            <option>06:00 PM</option>
                                                            <option>06:30 PM</option>
                                                            <option>07:00 PM</option>
                                                            <option>07:30 PM</option>
                                                            <option>08:00 PM</option>
                                                            <option>08:30 PM</option>
                                                            <option>09:00 PM</option>
                                                            <option>09:30 PM</option>
                                                            <option>10:00 PM</option>
                                                            <option>10:30 PM</option>
                                                        </select>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-2"><label className="d-md-block d-sm-none d-none">&nbsp;</label><Link onClick={() => deleteItem(s.scheduleTimingId)}  className="btn btn-danger trash"><i className="far fa-trash-alt"></i></Link></div>
                                    </div>
                                    {
                                        <div className = "row form-row hours-cont">
                                            <div className="error-message">
                                                {s.error}
                                            </div>
                                        </div>
                                    }
                                    
                                </div>
                            ))
                        }
                    </div>
                    <div className="add-more mb-3">
                        <Link onClick={() => AddMore()} className="add-hours"><i className="fa fa-plus-circle"></i> Add More</Link>
                    </div>
            </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => saveHandler()}>Save Changes</Button>
            </Modal.Footer>
        </Modal>
    );
}
 
export default EditTimeModel;